import { render, staticRenderFns } from "./PartBase.vue?vue&type=template&id=9637c904"
import script from "./PartBase.vue?vue&type=script&lang=js"
export * from "./PartBase.vue?vue&type=script&lang=js"
import style0 from "./PartBase.vue?vue&type=style&index=0&id=9637c904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports